import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './component/home';
import About from './component/About';
import Facility from './component/Facility';
import PublicDisclosureSection from './component/PublicDisclosure';
import Layout from './component/Layout'; // Import the Layout component
import Gallery from './component/Gallery';
import ContactUs from './component/ContactUs';
import Seo, { schoolSchema, webPageSchema } from './component/Seo';

const metaKeywords =
  'school in Partapur, best school in Partapur, school in Banswara, best school in Banswara, Rajasthan school, English medium school in Partapur, English medium school in Banswara, CBSE school in Banswara, school admission in Partapur, school admission in Banswara, senior secondary school in Partapur, private school in Banswara, top school in Partapur Rajasthan';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout> {/* Wrap the Routes with Layout */}
          <Routes>
            <Route
              index
              element={
                <>
                  <Seo
                    title="Best School in Partapur, Banswara | Maxfort Education School"
                    description="Maxfort Education School is a trusted English medium school in Partapur, Banswara, Rajasthan with strong academics, campus facilities, student activities, and admissions guidance."
                    keywords={metaKeywords}
                    path="/"
                    schema={schoolSchema}
                  />
                  <Home />
                </>
              }
            />
            <Route
              path="/about"
              element={
                <>
                  <Seo
                    title="About Maxfort Education School | School in Partapur, Banswara"
                    description="Learn about Maxfort Education School in Partapur, Banswara, including our teaching approach, student development focus, academic values, and school vision."
                    keywords={`${metaKeywords}, about school in Partapur, about Maxfort Education School, school vision and mission in Banswara`}
                    path="/about"
                    schema={webPageSchema(
                      'About Maxfort Education School',
                      'About the school, mission, vision, and learning philosophy.'
                    )}
                  />
                  <About />
                </>
              }
            />
            <Route
              path="/facility"
              element={
                <>
                  <Seo
                    title="School Facilities in Partapur | Maxfort Education School Banswara"
                    description="Explore the facilities at Maxfort Education School in Partapur, including library, playground, science labs, and student-friendly campus spaces."
                    keywords={`${metaKeywords}, school facilities in Partapur, science lab school in Banswara, library school in Partapur`}
                    path="/facility"
                    schema={webPageSchema(
                      'School Facilities at Maxfort Education School',
                      'Library, playground, labs, and facilities for students in Partapur, Banswara.'
                    )}
                  />
                  <Facility />
                </>
              }
            />
            <Route
              path="/publicdisclosure"
              element={
                <>
                  <Seo
                    title="Mandatory Public Disclosure | Maxfort Education School Partapur"
                    description="View the mandatory public disclosure, school information, certificates, and official documents for Maxfort Education School in Partapur, Banswara, Rajasthan."
                    keywords={`${metaKeywords}, mandatory public disclosure school, school documents in Banswara, CBSE school documents Partapur`}
                    path="/publicdisclosure"
                    schema={webPageSchema(
                      'Mandatory Public Disclosure',
                      'Official school information and mandatory public disclosure documents.'
                    )}
                  />
                  <PublicDisclosureSection />
                </>
              }
            />
            <Route
              path="/gallery"
              element={
                <>
                  <Seo
                    title="School Gallery | Maxfort Education School Partapur Banswara"
                    description="Browse the Maxfort Education School photo gallery featuring campus life, events, student activities, celebrations, and school moments from Partapur, Banswara."
                    keywords={`${metaKeywords}, school gallery Partapur, school photos Banswara, student activities school gallery`}
                    path="/gallery"
                    schema={webPageSchema(
                      'School Gallery',
                      'Campus life, events, activities, and school gallery images.'
                    )}
                  />
                  <Gallery />
                </>
              }
            />
            <Route
              path="/contact"
              element={
                <>
                  <Seo
                    title="Contact Maxfort Education School | Admission Enquiry in Partapur"
                    description="Contact Maxfort Education School in Partapur, Banswara for admissions, school enquiries, campus visit requests, phone support, and school address details."
                    keywords={`${metaKeywords}, contact school in Partapur, school admission enquiry Banswara, school contact details Partapur`}
                    path="/contact"
                    schema={webPageSchema(
                      'Contact Maxfort Education School',
                      'Admission enquiry, school contact details, address, and support.'
                    )}
                  />
                  <ContactUs />
                </>
              }
            />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
